
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    loggedUser: {},
  },
  getters: {
    loggedUser: state => state.loggedUser,
  },
  mutations: { // Synchronous
    setLoggedUser(state, user) {
      Vue.set(state, 'loggedUser', user);
    },
  },
  actions: { // can be async
  },
}